import React, { useCallback } from 'react';
import head from 'lodash/head';
import { useDispatch, useSelector } from 'react-redux';
import { ElectricVehicle, YamtIcon } from '@yme/assets/icons';
import { TypeA2 } from '@yme/assets/icons/license-types';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { NA_VALUE } from '@yme/common/constants';
import { useTouchOnly } from '@yme/hooks/useTouchOnly';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { setIsModalHide } from '@yme/modals/actions';
import { getIsInAuthor, getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { DigitalDataMutation, getImageSrc, setDigitalData } from '@yme/utils/common';
import { DRIVER_LICENSE_A2, ImageSuffix } from '@yme/utils/constants';
import { getProductURL } from '@yme/utils/product';
import { navigationItemFromLink } from '../Menu/utils';
import { ElectricType, MAP_LICENSE_TYPE_TO_ICON, ROLE_ICON } from './constants';
import { ElectricVehicleStyled, IconsWrapperStyled, ImageStyled, UnitCardPreview, UnitCardStyled, UnitCardTitle, YAMTIconStyled, } from './styled';
export function MenuUnitCard({ product: { rendition, shortName, driverLicense, slug, latestModel, year, electricVehicleIcon }, unitPath, isYAMTIconShowed, is35KWIconShowed, isDriverLicenseEnabled, label, isImageFullWidth = false, closeMenuHandler, }) {
    const dispatch = useDispatch();
    const isRightToLeft = useSelector(getRTL);
    const isInAuthor = useSelector(getIsInAuthor);
    const hideModal = useCallback(() => dispatch(setIsModalHide()), [dispatch]);
    const { isMobileView } = useWindowSize();
    const title = shortName ? `${latestModel ? '' : year} ${shortName}` : NA_VALUE;
    const newUrl = getProductURL({
        path: unitPath,
        isInAuthor,
        slug,
    });
    const isTouchDevice = useTouchOnly();
    const onUnitClickHandler = useCallback(() => {
        hideModal();
        closeMenuHandler();
        setDigitalData(DigitalDataMutation.NAVIGATION, {
            pageSection: 'main_menu',
            navigationGroup: '',
            navigationItem: navigationItemFromLink(newUrl),
        });
        window.scrollTo({
            top: 0,
        });
    }, [closeMenuHandler, hideModal, newUrl]);
    return (React.createElement(UnitCardStyled, { to: newUrl, onClick: onUnitClickHandler, isFullWidth: isImageFullWidth, isTouchDevice: isTouchDevice, isRightToLeft: isRightToLeft },
        React.createElement(IconsWrapperStyled, { alignItems: "center", justifyContent: isMobileView ? 'flex-end' : 'space-between', gap: isMobileView ? '8px' : undefined, isImageFullWidth: isImageFullWidth },
            isYAMTIconShowed && isMobileView && React.createElement(YAMTIconStyled, { type: YamtIcon }),
            React.createElement(FlexWrapper, null,
                isDriverLicenseEnabled && driverLicense && (React.createElement("span", { "aria-label": `${label}: ${driverLicense[0]}`, role: ROLE_ICON },
                    React.createElement(SVGIcon, { type: MAP_LICENSE_TYPE_TO_ICON[driverLicense[0]] }))),
                is35KWIconShowed && head(driverLicense) !== DRIVER_LICENSE_A2 && (React.createElement(SVGIcon, { type: TypeA2 }))),
            isYAMTIconShowed && !isMobileView && React.createElement(YAMTIconStyled, { type: YamtIcon })),
        React.createElement(UnitCardPreview, { isFullWidth: isImageFullWidth, isTouchDevice: isTouchDevice },
            React.createElement(ImageStyled, { alt: shortName, src: rendition ? getImageSrc(rendition, ImageSuffix.Thumbnail) : '', isFullWidth: isImageFullWidth, errorPlaceholderHasBackground: false })),
        React.createElement(UnitCardTitle, { isRightToLeft: isRightToLeft }, title),
        electricVehicleIcon === ElectricType.ELECTRIC_SCOOTER && (React.createElement(ElectricVehicleStyled, { isRightToLeft: true },
            React.createElement(SVGIcon, { type: ElectricVehicle })))));
}
